/* eslint-disable */
import createIcon from '../createIcon';

const IconArrowDownOutlined = createIcon({
  name: 'icon-arrow-down-outlined',
  content: '<path d="M828.248 516.524l-315.42 315.42-45.05-45.05 315.42-315.42z"/><path d="M242.013 471.155l315.42 315.42-45.05 45.05-315.42-315.42z"/><path d="M481.732 767.84V130.629h63.722v637.213z"/>',
  width: 1024,
  height: 1024
});
export default IconArrowDownOutlined;
